import { useState, useContext, useEffect } from 'react'
import { fetchWPItems } from '../fetch/fetchWPItems'
import { wooAddToCart, wooEditCartItem, wooDeleteCartItem } from '../fetch/WPAPI'
import { MainContext } from '../contexts/MainContext'
import useFavorites from './useFavorites'
import useCart from './useCart'
import useToken from './useToken.js'

export default function useProduct(props) {
  const { token, setToken, nonce, setNonce } = useToken()

  const [ currentProduct, setCurrentProduct ] = useState(props)

  const mainContext = useContext(MainContext)

  const { setCart } = useCart()

  const { favoriteItems, addFavoriteItem, removeFavoriteItem } = useFavorites()
  
  const [ addedToCart, setAddedToCart ] = useState(false)
  const [ updatedCartItem, setUpdatedCartItem ] = useState(false)

  const [ cartWeight, setCartWeight ] = useState(null)
  const [ cartType, setCartType ] = useState(null)
  const [ cartQty, setCartQty ] = useState(1)

  const [ variationId, setVariationId ] = useState(currentProduct.id)
  const [ variationPrice, setVariationPrice ] = useState(currentProduct.price)
  const [ variationPriceOld, setVariationPriceOld ] = useState(null)

  const [ weightDropdown, setWeightDropdown ] = useState(false)
  const [ typeDropdown, setTypeDropdown ] = useState(false)

  const [ variations, setVariations ] = useState(false)
  const [ weightsVariations, setWeightsVariations ] = useState(false)
  const [ grindsVariations, setGrindsVariations ] = useState(false)

  useEffect(() => {
    if (!mainContext.cartItems.find(elem => elem.id == currentProduct.id)) {
      setAddedToCart(false)
    }
  }, [mainContext.cartItems])

  const handleChangeWeight = (weight) => {
    setWeightDropdown(false)
    setCartWeight(weight)
    handleChangeVariation(weight, cartType)
  }

  const handleChangeType = (type) => {
    setTypeDropdown(false)
    setCartType(type)
    handleChangeVariation(cartWeight, type)
  }

  const findVariation = (weight, type, variations) => {
    return variations?.find(elem => {
      let weightChecked = weight ? elem.attributes.find(attribute => attribute.name == 'Вес' && attribute.option == weight) : true
      let typeChecked = type ? elem.attributes.find(attribute => attribute.name == 'Помол' && attribute.option == type) : true
      return weightChecked && typeChecked
    })
  }

  const handleChangeVariation = (weight, type, data = null) => {
    if (!data) {
      data = variations
    }
    let variation = findVariation(weight, type, data)

    if (variation) {
      setVariationId(variation.id)
      if (addedToCart) {
        setCart(mainContext.cartItems.map(elem => elem.id == currentProduct.id ? {...elem, variationId: variation.id, cartWeight: weight, cartType: type, cartPrice: variation.price} : elem))

        // if (token?.token && nonce) {
        //   wooDeleteCartItem(backendCartId, token.token, nonce)
        //     .then(result => {
        //       console.log(result)
        //     })

        //   wooAddToCart({ id: variation.id, quantity: cartQty }, token.token, nonce)
        //     .then(result => {
        //       console.log(result)
        //       let addedItem = result?.items?.find(elem => elem.id == variation.id)
        //       if (addedItem) {
        //         setBackendCartId(addedItem.key)
        //       }
        //     })
        // }
      }

      if (variation.sale_price) {
        setVariationPrice(variation.sale_price)
        setVariationPriceOld(variation.regular_price)
      } else {
        setVariationPrice(variation.price)
        setVariationPriceOld(null)
      }
    }
  }

  const handleQtyRaise = () => {
    setCartQty(cartQty + 1)

    if (addedToCart) {
      setCart(mainContext.cartItems.map(elem => elem.id == currentProduct.id ? {...elem, cartQty: cartQty + 1} : elem))

      // if (token?.token && nonce) {
      //   wooEditCartItem(backendCartId, {quantity: cartQty + 1}, token?.token, nonce)
      //     .then(result => {
      //       console.log(result)
      //     })
      // }
    }
  }

  const handleQtyLower = () => {
    if (cartQty > 1) {
      setCartQty(cartQty - 1)

      if (addedToCart) {
        setCart(mainContext.cartItems.map(elem => elem.id == currentProduct.id ? {...elem, cartQty: cartQty - 1} : elem))

        // if (token?.token && nonce) {
        //   wooEditCartItem(backendCartId, {quantity: cartQty - 1}, token?.token, nonce)
        //     .then(result => {
        //       console.log(result)
        //     })
        // }
      }
    }
  }

  const handleAddToCart = () => {
    setUpdatedCartItem(false)
    let newItem = {
      ...currentProduct,
      variationId: variationId,
      cartWeight: cartWeight,
      cartType: cartType,
      cartQty: cartQty,
      cartPrice: variationPrice,
      cartPriceOld: variationPriceOld,
    }

    setAddedToCart(true)

    let item = mainContext.cartItems.find(e => e.id == currentProduct.id)
    if (item) {
      // setCart([
      //   newItem,
      //   ...mainContext.cartItems.filter(elem => elem.id != currentProduct.id)
      // ])
    } else {
      // if (token?.token && nonce) {
      //   wooAddToCart({ id: variationId, quantity: cartQty }, token.token, nonce)
      //     .then(result => {
      //       console.log(result)
      //       let addedItem = result?.items?.find(elem => elem.id == variationId)
      //       if (addedItem) {
      //         setBackendCartId(addedItem.key)
      //       }
      //     })
      // }

      setCart([
        newItem,
        ...mainContext.cartItems
      ])
    }
  }

  const setParametersVariations = (data) => {
    let itemVariations = mainContext.catalogItemsVariations.find(elem => elem.categoryId == 17 && elem.id == currentProduct.id)
    if (!itemVariations) {
      mainContext.setCatalogItemsVariations((prev) => [...prev, { categoryId: 17, id: currentProduct.id, data: data }]) // TODO check category
    }

    let weights = [...new Set(data.map(elem => {
      let attribute = elem.attributes.find(elem => elem.name == 'Вес')
      if (attribute) {
        return attribute.option
      }
    }))].filter(elem => typeof(elem) != 'undefined')
    setWeightsVariations(weights)
    
    let grinds = [...new Set(data.map(elem => {
      let attribute = elem.attributes.find(elem => elem.name == 'Помол')
      if (attribute) {
        return attribute.option
      }
    }))].filter(elem => typeof(elem) != 'undefined')
    setGrindsVariations(grinds)

    if (!mainContext.cartItems.find(e => e.id == currentProduct.id)) {
      let updatedWeight = null
      let attributesWeights = currentProduct.attributes.find(elem => elem.name == 'Вес')
      if (attributesWeights && attributesWeights.options && attributesWeights.options.length > 0) {
        updatedWeight = attributesWeights.options[0]
        setCartWeight(updatedWeight)
      }

      let updatedGrind = null
      let attributesGrinds = currentProduct.attributes.find(elem => elem.name == 'Помол')
      if (attributesGrinds && attributesGrinds.options && attributesGrinds.options.length > 0) {
        updatedGrind = attributesGrinds.options[0]
        setCartType(updatedGrind)
      }

      handleChangeVariation(updatedWeight, updatedGrind, data)
    }
  }

  useEffect(() => {
    if (currentProduct.sale_price) {
      setVariationPrice(currentProduct.sale_price)
      setVariationPriceOld(currentProduct.regular_price)
    } else {
      setVariationPrice(currentProduct.price)
      setVariationPriceOld(null)
    }

    if (currentProduct.categories && currentProduct.categories.find(elem => elem.id == 17)) {
      let itemVariations = mainContext.catalogItemsVariations.find(elem => elem.categoryId == 17 && elem.id == currentProduct.id)
      if (itemVariations) {
        setVariations(itemVariations.data)
        setParametersVariations(itemVariations.data)
      } else {
        if (currentProduct.id) {
          let apiUrl = `https://panel.rockets.coffee/wp-json/public-woo/v1/products/${currentProduct.id}/variations?per_page=100`
          fetchWPItems(apiUrl)
            .then(result => {
              setVariations(result)
              setParametersVariations(result)
            })
        }
      }
    }

    let cartItem = mainContext.cartItems.find(e => e.id == currentProduct.id)
    if (cartItem) {
      setAddedToCart(true)
      setCartWeight(cartItem.cartWeight)
      setCartType(cartItem.cartType)
      setCartQty(cartItem.cartQty)
      setVariationPrice(cartItem.cartPrice)
      setVariationPriceOld(cartItem.cartPriceOld)
    } else {
      setAddedToCart(false)
      setCartQty(1)
    }
  }, [currentProduct])

  return {
    currentProduct: currentProduct,
    setCurrentProduct: setCurrentProduct,
    favoriteItems: favoriteItems,
    addFavoriteItem: addFavoriteItem,
    removeFavoriteItem: removeFavoriteItem,
    addedToCart: addedToCart,
    updatedCartItem: updatedCartItem,
    cartWeight: cartWeight,
    cartType: cartType,
    cartQty: cartQty,
    variationId: variationId,
    variationPrice: variationPrice,
    variationPriceOld: variationPriceOld,
    weightDropdown: weightDropdown,
    setWeightDropdown: setWeightDropdown,
    typeDropdown: typeDropdown,
    setTypeDropdown: setTypeDropdown,
    weightsVariations: weightsVariations,
    grindsVariations: grindsVariations,
    handleChangeWeight: handleChangeWeight,
    handleChangeType: handleChangeType,
    handleQtyRaise: handleQtyRaise,
    handleQtyLower: handleQtyLower,
    handleAddToCart: handleAddToCart,
  }
}